import React, { useRef, useState } from "react";
import UiModal from "../../common/ui/UiModal";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { ERRORS } from "../../constants/user-info.const";
import { AddressInfoFormFields, HomeAddress, State } from "../models/user-interface";
import HomeAddressForm from "../user-forms/HomeAddressForm";
import { connect } from "react-redux";
import { formSubmitErrorHandler } from "../../../services/formService";
import { updateEmpAddress } from "../../../services/employeeService";
import Loader from "../../common/Loader";
interface ModalProps {
  open: boolean;
  handleClose: (result?: any, action?: any) => void;
  homeAddress: HomeAddress | undefined;
  usStates: any;
  AddressUpdateCallback: (result?: any) => void;
}
function AddressInfoEditModal(props: ModalProps) {
  const { open, handleClose, homeAddress, usStates, AddressUpdateCallback } = props;
  const title = "Edit Employee Address";
  const formRef: any = useRef();
  const [isShowFooterLoader, setIsShowFooterLoader] = useState<boolean>(false);

  const validationSchema = Yup.object({
    street_1: Yup.string().required(ERRORS.street),
    street_2: Yup.string(),
    city: Yup.string().required(ERRORS.city),
    state: Yup.object().required(ERRORS.state).nullable(),
    zip: Yup.string().required(ERRORS.zipCode),
  });
  const getFormData = (data : AddressInfoFormFields) =>{
    const formData = {
      version: homeAddress?.version,
      street_1: data?.street_1,
      street_2: data?.street_2,
      city: data?.city,
      state: data?.state?.id,
      zip: data?.zip,
    };
    return formData;
  }
  const onSubmit = (
    data : AddressInfoFormFields,
    formHelpers: FormikHelpers<any>
  ) => {
    const formInputs = getFormData(data);
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      updateEmpAddress(formInputs).then((res : any) => {
        setIsShowFooterLoader(false);
        AddressUpdateCallback(res?.data);
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };
  return (
    <UiModal
      open={open}
      handleClose={handleClose}
      title={title}
      handleSave={() => {
        formRef.current?.handleSubmit();
      }}
      showFooterLoader={isShowFooterLoader}
    >
      <div>
        <Formik
          initialValues={{
            street_1: homeAddress?.street_1 ?? "",
            street_2: homeAddress?.street_2 ?? "",
            city: homeAddress?.city ?? "",
            state:
              usStates?.find((state) => state.id === homeAddress?.state) ?? {},
            zip: homeAddress?.zip ?? "",
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
          innerRef={formRef}
        >
          {() => {
            return (
              <Form>
                <HomeAddressForm states={usStates} />
              </Form>
            );
          }}
        </Formik>
      </div>
      
    </UiModal>
  );
}
const mapStateToProps = (state) => ({
  usStates: state.config?.employees?.states,
});
export default connect(mapStateToProps)(AddressInfoEditModal);
